// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"f41d7986dae865bd1a36","293":"d2b15eb9614771bfe0cb","518":"e38d86df8042aaf20fd3","779":"c28fcfc87722eb0757dd"}[chunkId] + ".js";
};